import { AdditionalDriverItem } from 'directFlow/state/types'

import { OptionItem } from 'types'

export const generateAdditionalDriverNames = (
  additionalDrivers: AdditionalDriverItem[],
): OptionItem[] => {
  const options = additionalDrivers.map((driver) => {
    const fullName = `${driver.firstName || ''} ${driver.lastName || ''}`

    return { label: fullName, value: driver.id }
  })

  const policyHolder = { label: 'Me (policyholder)', value: 'Policyholder' }
  options.unshift(policyHolder)

  return options
}
